import { regionPath, type Region } from "./region";

export type RegionPaths = Record<Region, string[]>;

const ROUTE_PAGES = new Set(["/", "/faqs", "/blog", "/search"]);
const REGION_CHOICE_COOKIE = "tf:region-suggest";

export function regionAgnosticPath(pathname: string): string {
  const path = pathname === "/uk" || pathname.startsWith("/uk/") ? pathname.slice(3) : pathname;
  return path.replace(/\/+$/, "") || "/";
}

export function regionSwitchHref(to: Region, pathname: string, paths: RegionPaths): string {
  const path = regionAgnosticPath(pathname);
  const available = paths[to];
  if (ROUTE_PAGES.has(path) || available.length === 0 || available.includes(path)) {
    return regionPath(path, to);
  }

  const [section, child] = path.split("/").filter(Boolean);
  if (section === "faqs") {
    return regionPath(available.includes(`/faqs/${child}`) ? `/faqs/${child}` : "/faqs", to);
  }
  if (section === "blog") return regionPath("/blog", to);
  return regionPath("/", to);
}

export function hasSettledRegionChoice(): boolean {
  return document.cookie.split("; ").some((c) => c === `${REGION_CHOICE_COOKIE}=1`);
}

export function settleRegionChoice() {
  document.cookie = `${REGION_CHOICE_COOKIE}=1; path=/; max-age=31536000; samesite=lax`;
}
